<template>
  <div class="reportTempComponent">
    <h2 class="reportAddress">{{hospitalCenterName}}</h2>
    <div class="patientInfo">
      <Row :gutter="24">
        <Col :span="8">
          <span>姓名：{{patientName}}</span>
        </Col>
        <Col :span="9">
          <span>性别：{{patientGender}}</span>
        </Col>
        <Col :span="7">
          <span>年龄：{{patientAge}}{{ageUnit|getAgeUnit}}</span>
        </Col>
      </Row>
      <Row :gutter="24">
        <Col :span="8">
          <span>检查时间：{{checkTime}}</span>
        </Col>
        <Col :span="9">
          <span>报告单号：{{reportCode}}</span>
        </Col>
        <Col :span="7">
          <span>影像号：{{matchedFilmNo}}</span>
        </Col>
      </Row>
    </div>
    <Row :gutter="24" class="checkInfo">
      <Col :span="8">
        <span>检查项目：{{deviceCategoryName}}</span>
      </Col>
      <Col :span="16" class="checkBody">
        <div class="labelText">检查部位：</div>
        <Input v-model="checkBody" :disabled="type!=='edit'" v-if="type !== 'print'"/>
        <span v-if="type === 'print'">{{checkBody}}</span>
      </Col>
    </Row>
    <!-- 影像表现 -->
    <div class="performe">
      <div class="labelTitle">
        <span>影像表现</span>
        <span class="remainder" v-if="type!=='print'">剩余{{700- imageRepresentation.length}}字</span>
      </div>
      <TextArea :autosize="{ minRows:10, maxRows: 12 }" v-model="imageRepresentation" maxlength="700" v-if="type=='edit'"/>
      <div v-if="type!=='edit'" class="diagnoseText" :class="{printResult: type=== 'print'}" id="reportRepresent">{{imageRepresentation}}</div>
    </div>
    <!-- 影像诊断 -->
    <div class="performe">
      <div class="labelTitle">
        <span>影像诊断</span>
        <span class="remainder" v-if="type!=='print'">剩余{{700- diagnosticResult.length}}字</span>
      </div>
      <TextArea :autosize="{ minRows:10, maxRows: 12 }" v-model="diagnosticResult" maxlength="700" v-if="type=='edit'" id="diagnosticTextArea" @focus="diagnosticTextArea" @blur="checkOverLine"  @change="checkOverLine" @keydown="checkOverLineEnter"/>
      <div v-if="type!=='edit'" class="diagnoseText" :class="{printResult: type=== 'print'}" id="reportDiagnose">{{diagnosticResult}}</div>
    </div>
    <div style="color:red;" class="performe" v-if="overLineFlag">您已超出最大打印报告行数”12行“，请自行调整报告内容</div>
    <!-- 诊断属性 -->
    <div class="diagnosticAttributes" v-if="type!=='print'">
      <label>诊断属性：</label>
      <RadioGroup v-model="positiveNegative" :disabled="type!=='edit'">
        <RadioButton value="0">阴性</RadioButton>
        <RadioButton value="1">阳性</RadioButton>
      </RadioGroup>
    </div>
    <!-- 病种标签 -->
    <div class="dieaseLabel" v-if="type!=='print'">
      <div class="selDieaseLabel">
        <label>病种标签：</label>
        <Select :getPopupContainer="triggerNode =>(triggerNode.parentNode)" mode="multiple" labelInValue allowClear  :disabled="type!=='edit' || positiveNegative.toString()=== '0'" class="selectList" :filterOption="false" @search="searchDiease"  @change="selectDiease" :notFoundContent="dieaseLoading ? undefined : null" v-model="diseaseList" optionLabelProp="name">
          <Option v-for="item in fetchDieases" :key="item.id + '|'+item.icd10_code" :name="item.name">{{item.icd10_code}}{{item.name}}</Option>
          <Spin v-if="dieaseLoading" slot="notFoundContent"/>
        </Select>
      </div>
      <div class="diseaseRemark">
        <label>病种备注：</label>
        <Input v-model="dieaseRemark" :disabled="type!=='edit' || positiveNegative.toString()=== '0'" v-if="type !== 'print'"/>
      </div>
    </div>
    <!-- 添加模板 -->
    <div class="saveTemplate">
      <a @click="saveTemplate" v-if="type!=='print'">存为模板</a>
    </div>

    <!-- 医生签名 -->
    <Row :gutter="24" class="doctorSign">
      <Col :span="12">
        <label>报告医师：{{writeDoctor | changeDoctorName('write')}}</label>
      </Col>
      <Col :span="12">
        <label>审核医师：{{checkDoctor | changeDoctorName('check')}}</label>
        <div class="reportDate" v-if="type === 'print'">报告日期：2019-12-01</div>
      </Col>
    </Row>
    <!-- 注意（打印显示） -->
    <div class="reportTip" v-if="type === 'print'">
      <span>注：本报告仅供临床医师参考</span>
    </div>
  </div>
</template>
<script>
import { Row, Col, Input, Radio, Select, Spin } from 'ant-design-vue'
import { mapState, mapActions } from 'vuex'
import { getDieaseByVal} from '../../api/report'
export default {
  components: {
    Col,
    Row,
    Input,
    TextArea: Input.TextArea,
    RadioButton: Radio.Button,
    RadioGroup: Radio.Group,
    Select,
    Option: Select.Option,
    Spin
  },
  props: {
    type: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    ...mapState({
      patientName: state => state.report.patientName,
      patientAge: state => state.report.patientAge,
      ageUnit: state => state.report.ageUnit,
      patientGender: state => state.report.patientGender,
      reportId: state => state.report.reportId, // 报告ID
      hospitalCenterName: state => state.report.hospitalCenterName, // 影像中心
      checkTime: state => state.report.checkTime, // 检查时间
      reportCode: state => state.report.reportCode, // 报告单号
      matchedFilmNo: state => state.report.matchedFilmNo, // 影像单号
      deviceCategoryName: state => state.report.deviceCategoryName, // 检查项目
      writeDoctor: state => state.report.writeDoctor, // 编写医生
      checkDoctor: state => state.report.checkDoctor, // 审核医生
      overLineFlag: state => state.report.overLineFlag
    }),
    checkBody: {
      get () {
        return this.$store.state.report.checkBody
      },
      set (val) {
        this.setCheckBody(val)
      }
    },
    imageRepresentation: {
      get () {
        return this.$store.state.report.imageRepresentation
      },
      set (val) {
        this.setImageRepresentation(val)
      }
    },
    diagnosticResult: {
      get () {
        return this.$store.state.report.diagnosticResult
      },
      set (val) {
        this.setDiagnosticResult(val)
      }
    },
    positiveNegative: {
      get () {
        return this.$store.state.report.positiveNegative ? '1' : '0'
      },
      set (val) {
        val = val === '1' ? true : false
        if (!val) {
          this.setDieaseList([])
          this.dieaseRemark = ''
        }
        this.setPositiveNegative(val)
      }
    },
    diseaseList: {
      get () {
        return this.$store.state.report.diseaseList
      },
      set (val) {
        this.setDieaseList(val)
      }
    },
    dieaseRemark: {
      get () {
        return this.$store.state.report.dieaseRemark
      },
      set (val) {
        this.setDieaseRemark(val)
      }
    }
  },
  data () {
    return {
      dieaseKeyWrod: '', // 搜索关键词
      fetchDieases: [], // 疾病标签列表
      dieaseLoading: false,
      searchTimer: null,
      keyDownVal: ''
    }
  },
  methods: {
    ...mapActions([
      'setDiagnosticResult',
      'setImageRepresentation',
      'setPositiveNegative',
      'setDieaseList',
      'setCheckBody',
      'setDieaseRemark',
      'setOverLineFlag'
    ]),
    saveTemplate () {
      let params = {
        imageShow: this.imageRepresentation,
        imageDiagnose: this.diagnosticResult,
        diseaData: this.diseaseList,
        templateName: this.checkBody
      }
      this.$emit('saveTemplate', params)
    },
    async searchDiease (val) {
      if (this.searchTimer || !val || !val.trim()) return false
      this.searchTimer = setTimeout(async() => {
        this.dieaseLoading = true
        this.fetchDieases = []
        this.dieaseKeyWrod = val.trim()
        let list = await getDieaseByVal({value: val.trim()})
        if (list && list.length > 0) this.fetchDieases = list
        this.dieaseLoading = false
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }, 1000)
    },
    selectDiease (val) {
      let dieaseList = []
      for (let i = 0; i < val.length; i++) {
        let item = val[i]
        let idAndKey = item.key.split('|')
        dieaseList.push({key: item.key, id: idAndKey[0], originKey: idAndKey[1], label: item.label})
      }
      this.fetchDieases = []
      this.dieaseLoading = false
      this.setDieaseList(dieaseList)
    },
    checkOverLineEnter (e) {
      this.keyDownVal = e.code
      let lineFeed = this.diagnosticResult.match(/\n/ig)
      if (lineFeed && lineFeed.length > 12) {
        this.setOverLineFlag(true)
        if (e.preventDefault && e.code !== 'Backspace') e.preventDefault()
        else if (e.code !== 'Backspace') return window.event.value = false
        return false
      }
    },
    checkOverLine () {
      let dom = document.getElementById('diagnosticTextArea')
      if (!dom || !dom.scrollHeight) return false
      if (dom.scrollHeight > 296) {
        this.setOverLineFlag(true)
        if (this.diagnosticResult)
        this.setDiagnosticResult(this.diagnosticResult.replace(/^\s+|\s+$/g,''))
        if (this.keyDownVal !== 'Backspace') {
          dom.blur()
        }
      } else {
        this.setOverLineFlag(false)
      }
    },
    diagnosticTextArea() {
      this.setOverLineFlag(false)
    }
  }
}
</script>
<style lang="less">
@import url('../../style/common/variable.less');
.reportTempComponent{
  width: 21cm;
  margin: 0 auto;
  background-color: @baseColor;
  padding: 0 30px 60px 30px;
  border:1px solid @divideLineColor;
  font-size:@middleFontSize;
  font-weight: 500;
  .ant-input{
    font-size:@middleFontSize;
  }
  .reportAddress{
    text-align: center;
    font-size: @titleFontSize;
    padding: 40px 0 20px 0;
  }
  .patientInfo{
    border-top: 1px solid @secondFontColor;
    border-bottom: 1px solid @secondFontColor;
    padding: 10px 0;
    line-height: 2;
  }
  .checkInfo{
    padding: 20px 0;
    .checkBody{
      display: flex;
      align-items: center;
      .labelText{
        width:100px;
      }
    }
  }
  .performe{
    margin-bottom: 20px;
    .labelTitle{
      display: flex;
      justify-content: space-between;
      .remainder{
        justify-self: flex-end;
      }
    }
  }
  .dieaseLabel{
    margin-top: 15px;
    display: flex;
    align-items: center;
    .selDieaseLabel{
      position: relative;
      flex:1;
      display: flex;
      .selectList{
        flex:1;
      }
    }
    .diseaseRemark{
      flex:1;
      display: flex;
      align-items: center;
      margin-left: 10px;
      .ant-input{
        flex:1;
      }
    }
  }
  .diagnoseText{
    height: 230px;
    border: 1px solid #333;
    overflow: auto;
    text-align: left;
    padding: 3px;
    white-space: pre-wrap;
  }
  .printResult{
    border:none;
  }
  .doctorSign{
    padding: 10px 0;
    .reportDate{
      padding-top: 10px;
    }
  }
  .saveTemplate{
    text-align: right;
  }
  .reportTip{
    border-top:1px solid #333;
    padding-top: 10px;
  }
}
</style>